import { useState, useMemo } from "react";

/**
 * @param {boolean} [initial]
 * @returns {[boolean, { toggle: () => void, off: () => void, on: () => void }]}
 */
const useToggle = (initial = false) => {
  const [value, setValue] = useState(initial);

  const actions = useMemo(
    () => ({
      toggle: () => setValue((prev) => !prev),
      off: () => setValue(false),
      on: () => setValue(true),
    }),
    [],
  );

  return [value, actions];
};

export default useToggle;
